const iterableDivision = 'Brand';
const iterableBrand = 'Penguin Newsletter';
const iterableApiUrl = 'https://www.penguin.co.uk/api/forms/shop-newsletter';
const iterableFormName = 'Penguin Newsletter';

const iterableFormSelector = '.email-signup__form';

const getNotice = (formNode) => {
  let notice = formNode.querySelector('.iterableForm__notice');

  if (!notice) {
    notice = document.createElement('div');
    notice.className = 'iterableForm__notice email-signup__message';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.setAttribute('tabindex', '-1');

    formNode.appendChild(notice);
  }

  return notice;
};

const getIterableSuccess = (formNode) => {
  const notice = getNotice(formNode);

  notice.textContent =
    'Thank you for signing up to the Penguin newsletter.';

  const inputGroup = formNode.querySelector(
    '.email-signup__input-group'
  );

  const emailInput = formNode.querySelector(
    'input[type="email"]'
  );

  if (emailInput) {
    emailInput.value = '';
  }

  if (inputGroup) {
    inputGroup.hidden = true;
  }

  notice.focus();

  document.dispatchEvent(new CustomEvent('form-success'));
};

const getIterableFail = (formNode) => {
  const notice = getNotice(formNode);

  notice.textContent =
    'There was an error submitting the form. Please try again later.';

  notice.focus();

  document.dispatchEvent(new CustomEvent('form-error'));
};

const sendIterableForm = async (signupData, formNode) => {
  try {
    const response = await fetch(iterableApiUrl, {
      method: 'POST',
      body: new URLSearchParams(signupData),
    });

    let data;

    try {
      data = await response.json();
    } catch {
      throw new Error(
        `Newsletter endpoint returned ${response.status} with invalid JSON`
      );
    }

    if (!response.ok || !data?.success) {
      throw new Error(
        `Newsletter signup failed with status ${response.status}`
      );
    }

    getIterableSuccess(formNode);
  } catch (error) {
    console.error('Iterable newsletter signup failed:', error);
    getIterableFail(formNode);
  }
};

document.addEventListener('submit', async (event) => {
  const formNode = event.target;

  if (
    !(formNode instanceof HTMLFormElement) ||
    !formNode.matches(iterableFormSelector)
  ) {
    return;
  }

  event.preventDefault();

  const emailInput = formNode.querySelector('input[type="email"]');

  if (!emailInput || !emailInput.checkValidity()) {
    emailInput?.reportValidity();
    document.dispatchEvent(new CustomEvent('form-error'));
    return;
  }

  if (formNode.dataset.iterableSubmitting === 'true') {
    return;
  }

  formNode.dataset.iterableSubmitting = 'true';

  const submitButton = formNode.querySelector(
    'button[type="submit"], input[type="submit"]'
  );

  if (submitButton) {
    submitButton.disabled = true;
  }

  const notice = formNode.querySelector('.iterableForm__notice');

  if (notice) {
    notice.textContent = '';
  }

  await sendIterableForm(
    {
      iterableDivision,
      iterableBrand,
      formName: iterableFormName,
      email: emailInput.value.trim(),
    },
    formNode
  );

  formNode.dataset.iterableSubmitting = 'false';

  if (submitButton) {
    submitButton.disabled = false;
  }
});